import { Box, Button, Stack } from '@mui/material';

interface BottomActionButtonsProps {
  handleSalvarRascunho?: () => void;
  handleEnviarAprovacao?: () => void;
  enviarAprovacaoTexto?: string;
  isFormValid?: boolean;
  handleCancelar?: () => void | Promise<void>;
  cancelarTexto?: string;
  cancelarDisabled?: boolean;
}

export default function BottomActionButtons({
  handleSalvarRascunho,
  handleEnviarAprovacao,
  enviarAprovacaoTexto = 'Enviar para Aprovação',
  isFormValid = true,
  handleCancelar,
  cancelarTexto = 'Cancelar',
  cancelarDisabled = false
}: BottomActionButtonsProps): JSX.Element {
  return (
    <Stack direction='row' spacing={2} justifyContent='space-between' sx={{ pt: 2 }}>
      {handleCancelar && <Button
        variant='outlined'
        color='error'
        onClick={handleCancelar}
        disabled={cancelarDisabled}
      >
        {cancelarTexto}
      </Button>}

      <Box sx={{ display: 'flex', gap: 2 }}>
        {
          handleSalvarRascunho &&
          <Button
            variant='contained'
            color='info'
            onClick={handleSalvarRascunho}
          >
            Salvar Rascunho
          </Button>}

        {
          handleEnviarAprovacao &&
          <Button
            variant='contained'
            color='primary'
            onClick={handleEnviarAprovacao}
            disabled={!isFormValid}
          >
            {enviarAprovacaoTexto}
          </Button>}
      </Box>
    </Stack>
  )
}
